// Inspired by: https://hackernoon.com/how-to-build-a-stepper-with-compound-components-6a49d90950ba
// @ts-nocheck

import React, { PureComponent } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { colors } from '@lmc/common/constants'
import Swal from 'sweetalert2'
import { Button } from '@lmc/ui-kit'

export default class Step extends PureComponent<any, any> {
  checkValid = (nextFunc) => {
    const { isValid, validationText } = this.props
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      iconColor: colors.red,
      showConfirmButton: false,
      timer: 2000,
    })
    if (isValid && !isValid()) {
      return Toast.fire({
        type: 'warning',
        title: validationText,
      })
    }
    nextFunc()
  }

  render() {
    const {
      isActive,
      children,
      displayNext,
      displaySubmit,
      component,
      goToPreviousStep,
      goToNextStep,
      data,
      showNextButton,
      onSubmit,
      submitButtonText,
      stepHeader,
      stepFooter,
      bottom,
      buttonGlyph,
      stepStyles,
      isLoading,
      testId,
      ...formProps
    } = this.props

    if (isActive === false) return null

    return (
      <div data-testid={testId || 'step'}>
        <div
          style={{
            ...styles.formContainer,
            padding: isDesktop ? '80px 55px 30px' : '80px 0px 30px',
            ...stepStyles,
          }}
          data-testid={testId ? `${testId}-content` : 'step-content'}
        >
          {stepHeader}
          {React.createElement(component, {
            data,
            goToPreviousStep,
            goToNextStep,
            ...formProps,
          })}
          {stepFooter}
        </div>
        {children}
        <div data-testid={testId ? `${testId}-actions` : 'step-actions'}>
          <Next
            isActive={showNextButton && displayNext}
            goToNextStep={() => this.checkValid(goToNextStep)}
            testId={testId ? `${testId}-next` : 'step-next'}
          />
          <Submit
            isActive={displaySubmit && onSubmit}
            disabled={isLoading}
            onSubmit={() => this.checkValid(onSubmit)}
            text={submitButtonText}
            glyph={buttonGlyph}
            testId={testId ? `${testId}-submit` : 'step-submit'}
          />
        </div>
      </div>
    )
  }
}

const Next = ({ goToNextStep, isActive, testId }) => {
  if (!isActive) return null
  return (
    <div style={styles.nextButton} data-testid={testId || 'next-button'}>
      <Button
        onClick={goToNextStep}
        variant="primary"
        style={styles.center}
        dataTestId={testId ? `${testId}-button` : 'next-button'}
      >
        Next Step
      </Button>
    </div>
  )
}

const Submit = ({
  isActive,
  onSubmit,
  text,
  glyph,
  disabled = false,
  testId,
}) => {
  if (!isActive) {
    return null
  }
  if (glyph) {
    return (
      <div style={styles.nextButton} data-testid={testId || 'submit-button'}>
        <Button
          onClick={onSubmit}
          style={styles.center}
          variant="primary"
          disabled={disabled}
          dataTestId={testId ? `${testId}-button` : `btn-${text}`}
        >
          {text || 'Add this To-Do'}
        </Button>
      </div>
    )
  }
  return (
    <div style={styles.nextButton} data-testid={testId || 'submit-button'}>
      <Button
        onClick={onSubmit}
        variant="primary"
        disabled={disabled}
        style={styles.center}
        dataTestId={testId ? `${testId}-button` : `btn-${text}`}
      >
        {text || 'Add this To-Do'}
      </Button>
    </div>
  )
}

const isDesktop = isBrowser || isTablet

const styles = {
  formContainer: {
    paddingBottom: 24,
  },
  nextButton: {
    textAlign: 'center',
    paddingBottom: 120,
    display: 'flex',
    justifyContent: 'center',
  },
  center: {
    justifyContent: 'center',
  },
}
